/* 
 *  Created by SGiri 02/14/2018
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestComponent } from './bi-admin/request/request.component';
import { NewrequestComponent } from './bi-admin/newrequest/newrequest.component';
import { AuthGuard } from '~auth/guards';
import { DatasourceComponent } from './bi-admin/datasource/datasource.component';
import { DashboardDetailComponent } from '~config/dashboard-detail/dashboard-detail.component';
import { NewWidgetComponent } from '~config/new-widget/new-widget.component';
import { NewKpiComponent } from '~config/new-kpi/new-kpi.component';
import { SearchComponent } from '~config/search/search.component';
import { RepofolderDetailComponent } from '~config/repofolder-detail/repofolder-detail.component';
import { SyncwithcognosComponent } from '~config/syncwithcognos/syncwithcognos.component';
import { CognosSearchComponent } from '~cognos/cognos-search/cognos-search.component';
import { ListdatasourceComponent } from '~admin/datasource/listdatasource/listdatasource.component';
import { DataDictionaryComponent } from '~config/data-dictionary/dataDictionary.component';

const routes: Routes = [
  { path: '', redirectTo: '/requests', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardDetailComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'newWidget', component: NewWidgetComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'newKpi', component: NewKpiComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'search', component: SearchComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'repoFolderDetails', component: RepofolderDetailComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'syncWithCognos', component: SyncwithcognosComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'requests', component: RequestComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'newrequest', component: NewrequestComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'datasource', component: DatasourceComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'cognossearch', component: CognosSearchComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'listdatasources', component: ListdatasourceComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'dataDictionary', component: DataDictionaryComponent, canLoad: [AuthGuard], canActivate: [AuthGuard], canActivateChild: [AuthGuard] }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/app-routing.module.ts